export default __webpack_public_path__ + "static/media/123.1f828248.jpg";